import { Translation } from "../hooks/useTranslations";

const it: Translation = {
  common: {
    actions: "Azioni",
    actualCost: "Costo effettivo",
    add: "Aggiungi",
    addComponent: "Aggiungi Componente",
    allRequests: "Tutte le richieste",
    allowQuantityVariation: "Consenti variazione quantità",
    alreadyPresent: "Già presente",
    ascending: "Crescente",
    author: "Autore",
    availabilityDate: "Data di disponibilità",
    by: "Da",
    cancel: "Annulla",
    close: "Chiudi",
    closedAndDiscarded: "Chiuse e scartate",
    code: "Codice",
    columnNotFilterable: "Questa colonna non è filtrabile",
    columnNotSortable: "Questa colonna non è ordinabile",
    componentCantBeFinalItem: "Il componente non può essere lo stesso dell'articolo finale.",
    components: "Componenti",
    costs: "Costi",
    cost: "Costo",
    costPerUnit: "Costo per unità",
    createdAt: "Creato il",
    totalCost: "Costo totale",
    createRequest: "Crea richiesta",
    createsKit: "Crea Kit",
    dataHasBeenSavedSuccessfully: "I dati sono stati salvati con successo.",
    dataSyncedSuccessfully: "Dati sincronizzati con successo",
    days: "Giorni",
    decrease: (value: number) => `Riduci ${value}`,
    delete: "Elimina",
    deleteFilter: (filter: string) => `Elimina filtri per ${filter}`,
    description: "Descrizione",
    descending: "Decrescente",
    download: "Scarica",
    dragAndDropOrUploadAnFile: "Trascina e rilascia o clicca per caricare un file",
    dropIt: "Rilascia",
    edit: "Modifica",
    editMinutes: "Modifica Minuti",
    email: "Email",
    empty: "Vuoto",
    english: "Inglese",
    errorLoadingData: "Errore nel caricamento dei dati",
    expectedCost: "Costo previsto",
    expectedMinutes: "Minuti previsti",
    expectedQuantity: "Quantità prevista",
    exportExcel: "Esporta Excel",
    fieldCannotBeEmpty: "Il campo non può essere vuoto.",
    fieldContainsInvalidValueInsertBiggerOne: "Il campo contiene un valore non valido, inserire un valore maggiore.",
    fieldContainsInvalidValueInsertSmallerOne: "Il campo contiene un valore non valido, inserire un valore minore.",
    fieldInvalidValue: "Il campo contiene un valore non valido.",
    fieldValueInvalidFormat: "Il valore ha un formato non valido.",
    finalItem: "Articolo finale",
    finalItemCode: "Codice articolo finale",
    finalItemQuantity: "Quantità articolo finale",
    firstName: "Nome",
    genericError: "Si è verificato un errore, riprova.",
    generalData: "Dati generali",
    german: "Tedesco",
    groupedByItems: "Raggruppato per articoli",
    helmets: "Caschi",
    home: "Home",
    minutes: "Minuti",
    id: "ID",
    increase: (value: number) => `Aumenta ${value}`,
    initialItem: "Articolo iniziale",
    initialItemIsFinalItem: "L'articolo iniziale è l'articolo finale",
    initialItemQuantity: "Quantità articolo iniziale",
    isKit: "È un kit",
    italian: "Italiano",
    item: "Articolo",
    // itemsPerPackage: "Articoli per confezione",
    label: "Etichetta",
    lastName: "Cognome",
    loading: "Caricamento",
    logout: "Esci",
    manageCosts: "Gestisci costi",
    myArea: "La mia area",
    myRequests: "Le mie richieste",
    name: "Nome",
    nextNRows: (n: number) => `Prossime ${n} righe`,
    new: "Nuovo",
    newLabelOrPackaging: "Nuova etichetta/confezione",
    no: "No",
    noItemsFound: "Nessun elemento trovato.",
    notFound: "Non trovato",
    offerMandatory: "Offerta obbligatoria",
    onGoing: "In corso",
    optional: "Opzionale",
    organization: "Organizzazione",
    overwrite: "Sovrascrivi",
    packaging: "Confezione",
    permissions: "Permessi",
    producesKit: "Produce un kit",
    productionPickingNumber: "Numero produzione/picking",
    priorities: "Priorità",
    priority: "Priorità",
    processingType: "Tipo di lavorazione",
    processingTypes: "Tipi di lavorazione",
    previousNRows: (n: number) => `${n} righe precedenti`,
    pz: "PZ",
    quantity: "Quantità",
    rename: "Rinomina",
    requests: "Richieste",
    requestsByItem: "Richieste per articolo",
    requestType: "Tipo di richiesta",
    resourceNotFound: "La risorsa che stai cercando non è stata trovata.",
    roles: "Ruoli",
    save: "Salva",
    search: "Cerca",
    select: "Seleziona",
    selectRequestType: "Seleziona un tipo di richiesta.",
    send: "Invia",
    sendOfferTo: "Invia offerta a",
    showsMarketingFields: "Mostra campi marketing",
    status: "Stato",
    supervisor: "Supervisore",
    sync: "Sincronizza",
    testEnvironment: "Ambiente di test",
    totalAttachedDocuments: "Totale documenti allegati",
    type: "Tipo",
    types: "Tipi",
    unitOfMeasure: "Unità di misura",
    update: "Aggiorna",
    usedProducts: "Prodotti utilizzati",
    usedProductsFor: "Prodotti utilizzati per ",
    usedQuantity: "Quantità utilizzata",
    views: "Viste",
    workingMinutes: "Minuti lavorativi",
    writeMessage: "Scrivi un messaggio",
    yes: "Sì",
    youAreNotAllowedToAccessThisApplication: "Non sei autorizzato ad accedere a questa applicazione",
  },

  groupedRequests: {
    numberOfRequests: "Numero di richieste",
    totalExpectedMinutes: "Totale minuti previsti",
    totalExpectedMinutesCost: "Costo totale minuti previsti",
    productionTotalMinutes: "Totale minuti di produzione",
    totalProductionMinutesCost: "Costo totale minuti di produzione",
    totalInitialItemsCost: "Costo totale articoli iniziali",
    totalPackagingsAndLabelsCost: "Costo totale confezioni ed etichette",
    short: {
      numberOfRequests: "N. di richieste",
      totalExpectedMinutes: "Tot. min. previsti",
      totalExpectedMinutesCost: "Costo tot. min. previsti",
      productionTotalMinutes: "Tot. min. prod.",
      totalProductionMinutesCost: "Costo tot. min. prod.",
      totalInitialItemsCost: "Costo tot. articoli iniziali",
      totalPackagingsAndLabelsCost: "Costo tot. conf. ed etichette",
    },
  },

  processingRequests: {
    delete: "Elimina richiesta di lavorazione",
    plural: "Richieste di lavorazione",
    newProcessingRequest: "Nuova richiesta di lavorazione",
    editProcessingRequest: "Modifica richiesta di lavorazione",
    editAvailabilityDate: "Modifica data di disponibilità",
    requestRecap: "Riepilogo richiesta",

    questions: {
      delete: "Vuoi davvero eliminare questa richiesta di lavorazione?",
    },

    errors: {
      finalItemMoreInitialItems: "Un articolo finale può contenere solo un articolo iniziale",
      invalidAvailabilityDate: "Data di disponibilità non valida",
      notFound: "Richiesta di lavorazione non trovata",
      missingFinalItem: "Una richiesta di lavorazione deve contenere almeno un articolo finale",
      missingKitComponents: "Una richiesta di lavorazione kit deve contenere almeno un componente",
      missingPackagingsOrLabels: "Inserire confezioni o etichette per procedere",
      missingExpectedMinutes: "Inserire i minuti previsti per procedere",
      missingProductionMinutes: "Inserire i minuti di produzione per procedere",
    },

    status: {
      open: "Aperta",
      accepted: "Accettata",
      waitingConfirmation: "In attesa di conferma",
      offerApproved: "Offerta approvata",
      inProgress: "In corso",
      closed: "Chiusa",
      refused: "Rifiutata",
      discarded: "Scartata",
      actions: {
        takeInCharge: "Prendi in carico",
        sendOffer: "Invia offerta",
        accept: "Accetta",
        refuse: "Rifiuta",
        discard: "Scarta",
        start: "Inizia",
        finishClose: "Termina/Chiudi",
      },
      executedActions: {
        requestCreated: "Richiesta creata",
        requestAccepted: "Richiesta accettata",
        offerSent: "Offerta inviata",
        offerApproved: "Offer approvata",
        workStarted: "Lavorazione iniziata",
        workCompleted: "Lavorazione completata",
        offerRefused: "Offerta rifiutata",
        requestDiscarded: "Richiesta scartata",
      },
    },
  },

  labels: {
    plural: "Etichette",
    delete: "Elimina etichetta",
    newLabel: "Nuova etichetta",
    editLabel: "Modifica etichetta",

    questions: {
      delete: "Vuoi davvero eliminare questa etichetta?",
    },

    errors: {
      notFound: "L'etichetta richiesta non è stata trovata",
      codeExists: "Un'etichetta con il codice specificato è già definita",
      inUseByRequests: "L'etichetta è ancora in uso e non può essere eliminata",
    },
  },

  items: {
    plural: "Articoli",
    delete: "Elimina articolo",
    newItem: "Nuovo articolo",
    editItem: "Modifica articolo",
    deleteKitAndComponents: "Elimina kit e componenti",
    deleteJustKit: "Elimina solo il kit",
    deleteComponentsInfo: "I componenti utilizzati in altri kit o richieste non verranno eliminati",

    questions: {
      deleteComponents: "Vuoi eliminare i componenti associati a questo articolo?",
      delete: "Vuoi davvero eliminare questo articolo?",
    },

    errors: {
      notFound: "L'articolo richiesto non è stato trovato",
      alreadyExists: "L'articolo specificato è già definito",
      inUseByRequests: "L'articolo è ancora in uso e non può essere eliminato",
      alreadyAdded: "L'articolo selezionato è già stato aggiunto",
    },
  },

  users: {
    plural: "Utenti",
    addUser: "Aggiungi Utente",
    editUser: "Modifica Utente",

    errors: {
      notFound: "L'utente richiesto non è stato trovato",
      alreadyExists: "L'utente selezionato è già stato aggiunto",
      emailAlreadyExists: "Un altro utente con la stessa email è già stato aggiunto",
    },
  },

  costCenters: {
    singular: "Centro di costo",
    plural: "Centri di costo",
    delete: "Elimina centro di costo",
    newCostCenter: "Nuovo centro di costo",
    editCostCenter: "Modifica centro di costo",

    questions: {
      delete: "Vuoi davvero eliminare questo centro di costo?",
    },

    errors: {
      notFound: "Il centro di costo richiesto non è stato trovato",
      codeUsed: "Un centro di costo con il codice specificato è già definito",
      nameUsed: "Un centro di costo con il nome specificato è già definito",
      inUseByRequests: "Il centro di costo è ancora in uso e non può essere eliminato",
    },
  },

  costObjects: {
    singular: "Oggetto di costo",
    plural: "Oggetti di costo",
  },

  documents: {
    add: "Aggiungi documento",
    all: "Tutti i documenti",
    alreadyPresent: "Documento già presente.",
    plural: "Documenti",
    rename: "Rinomina documento",
    delete: "Elimina documento",
    search: "Cerca documenti",

    questions: {
      delete: "Vuoi davvero eliminare questo documento?",
      overwrite: "Vuoi sovrascrivere il documento già presente?",
    },

    errors: {
      nameAlreadyExists: "Un documento con il nome specificato è già presente",
      extensionChanged: "L'estensione del documento non può essere modificata",
      sizeTooLarge: "La dimensione del documento è troppo grande",
    },
  },

  notes: {
    note: "Nota",
    addNote: "Aggiungi nota",
    editNote: "Modifica Nota",
    plural: "Note",
  },

  priorities: {
    plural: "Priorità",
    delete: "Elimina priorità",
    newPriority: "Nuova priorità",
    editPriority: "Modifica priorità",

    questions: {
      delete: "Vuoi davvero eliminare questa priorità?",
    },

    errors: {
      notFound: "La priorità richiesta non è stata trovata",
      nameUsed: "Una priorità con il nome specificato è già definita",
      inUseByRequests: "La priorità è ancora in uso e non può essere eliminata",
    },
  },

  packagings: {
    plural: "Confezioni",
    delete: "Elimina confezione",
    newPackaging: "Nuova confezione",
    editPackaging: "Modifica confezione",

    questions: {
      delete: "Vuoi davvero eliminare questa confezione?",
    },

    errors: {
      notFound: "La confezione richiesta non è stata trovata",
      codeExists: "Una confezione con il codice specificato è già definita",
      inUseByRequests: "La confezione è ancora in uso e non può essere eliminata",
    },
  },

  processingRequestTypes: {
    delete: "Elimina tipo di richiesta",
    newType: "Nuovo tipo di richiesta",
    editType: "Modifica tipo di richiesta",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo di richiesta?",
    },

    errors: {
      notFound: "Il tipo richiesto non è stato trovato",
      nameUsed: "Un tipo di richiesta di lavorazione con il nome specificato è già definito",
      inUseByRequests: "Il tipo di richiesta di lavorazione è ancora in uso e non può essere eliminato",
    },
  },

  suppliers: {
    singular: "Fornitore",
    plural: "Fornitori",
    delete: "Elimina fornitore",
    newSupplier: "Nuovo fornitore",
    editSupplier: "Modifica fornitore",

    questions: {
      delete: "Vuoi davvero eliminare questo fornitore?",
    },

    errors: {
      notFound: "Il fornitore richiesto non è stato trovato",
      codeUsed: "Un fornitore con il codice specificato è già definito",
      inUseByRequests: "Il fornitore è ancora in uso e non può essere eliminato",
    },
  },

  errors: {
    genericError: "Si è verificato un errore, riprova.",
    finalItemCannotMatchInitialItem: "L'articolo finale non può corrispondere all'articolo iniziale",
  },

  warnings: {
    notAllComponentsDeleted: "Alcuni dei componenti del kit sono stati eliminati",
  },
};
export default it;
